<div class="wrapper">

  <div class="contentWrapper {{showingPopup ? 'blurredContent' : ''}}">




    <!-- header -->
    <div class="topContent">


      <div class="remainingSpace">
        <button
          [matTooltip]="'search.back.tooltip' | translate"
          class="icon-button header-icon-button"
          (click)="onBack()"
          >
          <tun-arrow-back36px-icon-v5 class="icon icon-large-scaled-svg-button"></tun-arrow-back36px-icon-v5>
        </button>
      </div>

      <div class="titleContainer">

        <button
          [disabled]="!(hasTracks$ | async)"
          [matTooltip]="'trackOptions.list.playAll' | translate"
          class="icon-button first-title-item {{checkedTracks.length > 0 ? 'no-focus' : ''}}"
          (click)="onPlayAll()"
          >
          <tun-play-icon-v5 class="icon colored-icon"></tun-play-icon-v5>
        </button>

        <div class="title">
          <button
            [matTooltip]="'search.back.tooltip' | translate"
            class="title-link-button"
            (click)="onBack()"
            >
            {{'search.tab.label' | translate }}:
          </button>
          <tun-scrollable-text class="searchTitle" [text]="searchTitle$ | async"></tun-scrollable-text>
        </div>

      </div>

      <div class="remainingSpace"></div>

    </div>

    <!-- search result content -->


    <!-- Special search states indicator -->

    @if (searchState != SearchState.normal) {
      <div
        class="feedback-container"
        >
        @switch (searchState) {
          @case (SearchState.searchError) {
            <div
              class="error-feedback-container"
              >
              <p>
                {{'search.status.failed' | translate }}
              </p>
              <button (click)="retryClick()" class="retryButton">
                <p>
                  {{'general.tryAgain' | translate }}
                </p>
              </button>
            </div>
          }
          @case (SearchState.searching) {
            <tun-loader-v5 class="loader"></tun-loader-v5>
          }
        }
      </div>
    }

    @if (searchState == SearchState.normal) {
      <tun-selectable-track-list-view
        class="trackTable"
        [tracks]="tracks$ | async"
        [checkedTracks]="checkedTracks"
        [audioFileProperty]="audioFileProperty$ | async"
        (checkedTracksChanged)="onCheckedTracksChanged($event)"
        (addTracksToPlaylist)="onAddTracksToPlaylist($event)"
        (showOptions)="onShowOptions($event)"
        >
      </tun-selectable-track-list-view>
    }


  </div>

  <!-- Popup: choose playlist-->
  @if (showChoosePlaylistOverlay) {
    <div #choosePlaylistPopupWrapper class="popupWrapper" @slideUpAnimation (click)="onClickOutside($event, choosePlaylistPopupWrapper)">
      <tun-overlay-select-playlist
        class="select-playlist-overlay"
        confirmButtonTranslateableText="playlist.addTrack.popup.button.commit"
        (closeWithPlaylist)="onCloseSelectPlaylist($event)"
        >
      </tun-overlay-select-playlist>
    </div>
  }

</div>
